export default function DiamondsRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 554 1408">
      <rect width="230" height="230" x="703.6" stroke="#F3F6F9" strokeWidth="4" rx="20" transform="rotate(45 704 0)" />
      <rect
        width="230"
        height="230"
        x="613.4"
        y="270.5"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 613 270)"
      />
      <rect
        width="230"
        height="230"
        x="342.9"
        y="360.6"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 343 361)"
      />
      <rect
        width="230"
        height="230"
        x="523.3"
        y="540.9"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 523 541)"
      />
      <rect
        width="230"
        height="230"
        x="703.6"
        y="721.2"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 704 721)"
      />
      <rect
        width="230"
        height="230"
        x="252.8"
        y="631.1"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 253 631)"
      />
      <rect
        width="230"
        height="230"
        x="433.1"
        y="811.4"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 433 811)"
      />
      <rect
        width="230"
        height="230"
        x="613.4"
        y="991.7"
        stroke="#F3F6F9"
        strokeWidth="4"
        rx="20"
        transform="rotate(45 613 992)"
      />
    </svg>
  )
}
